export const informationStyles = {
  popover: {
    container: { p: 2, maxWidth: 280 },
    rolesLabel: {
      color: "text.secondary",
      fontWeight: 700,
      letterSpacing: 1.2,
    },
    divider: { my: 1 },
    roleHeader: { display: "flex", alignItems: "center", gap: 1, mb: 1 },
    roleDesc: { mb: 1.5, color: "text.secondary" },
    chipsBox: { display: "flex", flexWrap: "wrap", gap: 0.5 },
    multisiteDesc: { color: "text.secondary" },
    root: { pointerEvents: "none" as const },
  },
  alert: {
    root: {
      mb: 1,
      mt: 1,
      py: 0.5,
      "& .MuiAlert-message": { py: 0.5 },
      "& .MuiAlert-icon": { py: 0.5 },
    },
    title: { fontWeight: 700, mb: 0, fontSize: "0.8rem" },
    chipsRow: {
      display: "flex",
      gap: 0.75,
      mt: 0.75,
      flexWrap: "wrap" as const,
    },
    rolesLabel: { fontWeight: 700, fontSize: "0.75rem" },
    chip: { cursor: "default" },
  },
};
